
export let frMessages={

  "privacy_policy_and_terms_of_use":"Privacy Policy and Terms of Use ",
  "privacy_confirm_text":"We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree":"Disagree",
  "privacy_confirm_accept":"Accept",


  "title":"EasyView Personal",
  "title1":"EasyView Pro",
  "user":"Email",
  "password":"Mot de pass",
  "remember":"Souvenez de moi",
  "forget":"Mot de passe oublié?",
  "sign in":"se connecter",
  "login":"Login",
  "sign up now":"S'inscrire maintenant",
  "apply":"Appliquer maintenant",
  "contact us":"Contactez nous",
  "Privacy Policy":"Politique de confidentialité",
  "Terms of Use":"Conditions d'utilisation",
  "copyright":"Copyright © 2021 Medtrum Technologies Inc. All rights reserved.",

  "chooseLang":"Choisissez votre pays ou votre langue",
  "asia":"Asie",
  "europe":"L'Europe ",

  "applyHcp":"Demander un compte HCP",
  "sign up":"S'inscrire",
  "Patient":"Patient",
  "Caregiver":"Soignant",
  "Email":"Email",
  "Mobile":"Mobile",
  "Enter email":"Entrer l'adresse e-mail",
  "Enter mobile":"Entrez le numéro de mobile",
  "Verification":"Code de vérification",
  "Invitation":"Invitation code",
  "full name":"Entrez votre nom complet",
  "Enter pass":"Entrer le mot de passe",
  "org":"Organisation",
  "Register":"Register",
  "send":"Envoyer",
  "agree":"J'ai lu et j'accepte la ",
  "privacy":"politique de confidentialité ",
  "and" :"et ",
  "use":"les conditions d'utilisation.",
  "errtip1-1":"Vous devez entrer une adresse email valide, qui",
  "errtip1-2":"deviendra votre nom d'utilisateur Medtrum.",
  "errtip2":"Please enter a valid mobile number.",
  "errtip3":"Code de vérification incorrect",
  "errtip4":"Incorrect invitation code.",
  "errtip5":"Nom d'utilisateur incorrect",
  "errtip6":"Your password must have 8 or more characters.",
  "errtip7":"Veuillez entrer votre organisation",

  "errp1":"Le mot de passe doit contenir au moins 3 types des caractères suivants:",
  "errp2":"lettre majuscule, lettre minuscule, numéro et caractère spécial.",
  "errp3":"Le mot de passe doit comporter entre 6 et 20 caractères.",
  "errp4":"Le mot de passe doit être différent du nom d'utilisateur.",
  "errp5":"Le mot de passe avec 3 numéros consécutifs est invalide (ex: 123, 321).",
  "errp6":"Le mot de passe avec 3 lettres consécutives est invalide (ex: abc, cba).",
  "errp7":"Le mot de passe ne peut pas contenir d'espaces.",


  "Find account":"Récupérez votre mot de passe.",
  "Enter username":"S'il vous plaît entrez votre nom d'utilisateur.",
  "Next":"Prochain",
  "Cancel":"Annuler",
  "Back":"retour",
  "Enter veri":"Entrer Code de vérification",
  "Verify notice":"Veuillez trouver le code de vérification dans un e-mail.",
  "Create new":"Crée un nouveau mot de passe",
  "Create new notice":"Veuillez créer un nouveau mot de passe, et votre mot de passe doit avoir 6 caractères ou plus.",
  "New pass" :"Nouveau mot de passe",
  "Completed":"Terminé",
  "Created":"Nouveau mot de passe créé.",
  "Login Now":"Connectez vous maintenant",

  "Delete":"Supprimer",
  "New Patient":"New Patient",
  "Add Patient":"Ajouter un patient",
  "Filter":"Sellectionner",
  "Name":"Nom",
  "Gender":"Sex",
  "Age":"Age",
  "Type":"Type",
  "Duration":"Durée",
  "Connections":"Créateur de compte",
  "UploadTime":"Temps de téléchargement",
  "Year":"année",
  "Years":"année",
  "Month":"month",
  "Month2":"Mois",
  "Months":"months",
  "Invite":"Inviter",
  "Invited":"Invité",
  "All":"Tout",
  "Female":"Femelle",
  "Male":"Mâle",
  "Not Set":"Non spécifié",
  "Type 1":"Type 1",
  "Type 2":"Type 2",
  "Gestational":"Gestationnel",
  "Prediabetes":"Prédiabète",
  "LADA":"Type 1.5 LADA",
  "Apply":"Appliquer",
  "disUn":"Type de diabète non spécifié",
  "ageUn":"Âge n'est pas renseigné",
  "genUn":"Sexe non renseigné",
  "addP":"Ajouter un patient",
  "newP":"Nouveau patient",
  "findP":"Trouver un patient",

  "GDRNF":"Non spécifié",
  "GDRF":"Femelle",
  "GDRM":"Mâle",
  "女":"Mâle",

  "DBTNF":"Non spécifié",
  "DBT1":"Type 1",
  "DBT2":"Type 2",
  "DBTLADA":"Type 1.5 LADA",
  "DBTPRE":"Prédiabète",
  "DBTGEST":"Gestationnel",
  "前期":"beFore",
  "beFore":"beFore",
  "MODY":"Mody",

  "No selection":"Non spécifié",
  "unspecif":"Non spécifié",
  "register":"Patient",
  "hcp":"Clinicien",

  "BG":"Glyc. Cap.",
  "CARB":"Glucides",
  "INS":"Injection",
  "EXR":"Exercice",
  "OTR":"Autres",
  "HBA1C":"HbA1c",
  "DOSE":"DOSE",
  "URINEK":"Cétone d'urine",
  "HEL":"HEL",
  "OTR1":"Autre",
  "Loading":"En cours de chargement",

  "home":"Accueil ",
  "pID":"ID du patient",
  "fullName":"Nom complet",
  "gender":"Sex",
  "height":"la taille",
  "weight":"Poids",
  "cm":"cm",
  "kg":"kg",
  "birthday":"Date de naissance",
  "disType":"Type de diabète",
  "disDate":"Date du diagnostic",
  "Address":"Adresse",
  "Postcode":"Code postal",
  "Inpatient":"Hospitalisé",
  "Yes":"Oui",
  "No":"no",
  "Pno":"No.Patient",
  "Bno":"No.Lit",
  "create":"Créer",
  "Telephone":"Telephone",

  "enterU":"Entrez le nom d'utilisateur (email)",
  "search":"Chercher",
  "noU":"Nom d'utilisateur est nécessaire.",
  "searchR":"Résultats de la recherche",
  "uername":"Nom d'utilisateur",
  "alias":"Alias",
  "remove":"Enlever",
  "viewG":"Voir les graphiques",
  "sendR":"Envoyer une demande",
  "rSent":"Votre demande à été envoyé.",
  "cancelR":"Demande d'annulation",

  "VcodeTip1":"Je ne l'ai pas reçu? Veuillez patienter une minute et ",
  "VcodeTip2":"réessayer.",
  "VcodeTip3":"Nous venons d'envoyer un code de vérification à ",
  "Entercode":"Entrez le code",
  "Getcode":"Obtenir le code",

  "messages":"Messages",
  "profile":"Profil",
  "sign out":"Déconnexion",
  "changeP":"Changer le mot de passe",
  "connection":"Connections",

  "myP":"Mon profil",
  "Portrait":"Photo de profil",
  "Profession":"Métier",
  "DPRONF":"Non spécifié",
  "DPROENDOCRIN":"Endocrinologue",
  "DPRODIABTRA":"Éducateur en diabète",
  "DPRONURSE":"Infirmière",
  "DPRODIATIT":"Nutritionniste",
  "DPROOTR":"Professionnelle de santé",
  "Organization":"Organization",
  "Bio":"bio",
  "save":"sauvegarder",
  "oldPa":"Ancien mot de passe",
  "newPa":"Nouveau mot de passe",
  "RePa":"Retaper le mot de passe",
  "forgetY":"Mot de passe oublié?",
  "applyM":"Appliquer",
  "oldErr":"L'ancien mot de passe est incorrect.",
  "EntTheSame":"Entrez le nouveau mot de passe à nouveau.",
  "EnterOld":"Entrez l'ancien mot de passe.",

  "pList":"Liste des patients",
  "connections":"Connexions",
  "settings":"Réglages",
  "monitor":"Moniteur",
  "graphs":"Rapports",
  "events":"Événements",
  "records":"Enregistrements",
  "qPrint":"Imprimé rapide",

  "sensorIn":"Infos sur le capteur",
  "timeOfLaRead":"Heure de la dernière lecture du capteur",
  "tranSn":"Transmetteur de NS",
  "status":"Statut",
  "sensorLife":"Durée de vie restante du capteur",
  "lastSenorRead":"Dernière lecture du capteur",
  "TranBattery":"Pile de l'émetteur",
  "sg":"capteur de glucose",
  "alert":"Alerte",
  "target":"Cible",
  "hypo":"hypoglycémie",
  "sensorGlucose":"Valeur de glucose",
  "calib":"Calibrage",
  "newSen":"Nouveau capteur",
  "warm":"Réchauffer",
  "InsulinPump":"Pompe à insuline",
  "timeOfLaPump":"Heure des dernières données de la pompe",
  "pumpSN":"Base de pompe deNS",
  "ReserviorLife":"Durée de vie du réservoir restante",
  "InsulinLeft":"Insuline restante",
  "basal":"Basal",
  "bolus":"Bolus",
  "totalBasal":"Total quotidien basal",
  "lastBolus":"Dernier bolus",
  "activeInsulin":"Insuline active",
  "totalBolus":"Bolus total quotidien",
  "tampBasal":"Basal Temporaire",
  "normalBolus":"Bolus normal",
  "extendBolus":"Bolus étendu",
  "manualStop":"Suspension manuelle",
  "autoStop":"Suspension automatique",
  "auto suspend":"Suspension automatique",
  "stop":"Arrêt d'administration",
  "newPatch":"Nouvelle pompe",
  "tempBasal":"Basal Temporaire",
  "N":"N",
  "E":"C",
  "CN1":"Duo-N",
  "CE":"Duo-C",

  "staticSettings":"Réglages de rapport",
  "dataSource":"La source de données",
  "unit":"Unité",
  "glucoseTarget":"Plage de cible de glucose",
  "overall":"Global",
  "Hypoglycemia":"Hypoglycémie",
  "timePeriod":"Période de temps",
  "postMeal":"Analyse post-repas",
  "Breakfast":"Petit Déjeuner",
  "Lunch":"Le déjeuner",
  "Dinner":"Dîner",
  "night":"La nuit",
  "Before":"Avant",
  "After":"Après",
  "Low":"Bas",
  "High":"Haute",
  "From":"De",
  "To":"À",
  "Hours":"heures",
  "Reset":"Réinitialiser",
  "RealTime":"Temps réél",
  "uploaded":"Téléchargé",
  "sensor":"Capteur",
  "pdmSN":"NS de PDM",
  "startTime":"Heure de début",
  "endTime":"Heure de fin",
  "uploadTime":"Temps de téléchargement",
  "pdm":"PDM",
  "Uploaded":"Téléchargé",
  "Patch Pump":"PDM",
  "overLapp":"Les sessions se chevauchaient",
  "showAlert":"Afficher les alertes",

  "dashboard":"Tableau de bord",
  "dboard_glucose_statistics":"Glucose Statistics",
  "dboard_glucose":"Glucose",
  "dboard_cgm":"CGM",
  "dboard_insulin":"Insulin",
  "dboard_carbs":"Carbs",
  "dboard_exercise":"Exercise",
  "dboard_glucose_avg":"Average",
  "dboard_cgm_avg":"Moyenne",
  "dboard_insulin_avg":"Average Daily Dose",
  "dboard_carbs_avg":"Moyenne glucides/jour",
  "dboard_exercise_avg":"Temps moyen/jour",
  "dboard_sd":"SD",
  "dboard_num":"#",
  "dboard_num_days":"# days",
  "dboard_statistics":"Statistics",
  "dboard_BG":"BG",
  "dboard_BG_calibration":"BG / calibration (per day)",
  "dboard_SG":"SG",
  "dboard_AUC_high":"AUC high >",
  "dboard_AUC_low":"AUC low <",
  "dboard_highest_value":"Valeur la plus élevée",
  "dboard_lowest_value":"Valeur la plus basse",

  "dboard_pump":"Pump",
  "dboard_avg_daily_dose":"Dose quotidienne moyenne",
  "dboard_SD":"ÉCART-TYPE",
  "dboard_daily_basal":"Basale Quotidienne",
  "dboard_daily_bolus":"Bolus Quotidien",
  "dboard_avg_bolus_num":"Nombre moyen de bolus quotidien",
  "dboard_avg_suspend_time":"Temps moyen d'arrêt de la pompe",
  "dboard_avg_reservoir_usage":"Utilisation moyenne du réservoir",
  "dboard_days":"days",

  "dboard_manual_bolus":"Bolus manuel (Volume/nombre par jour)",
  "dboard_normal":"-Normal",
  "dboard_extend":"-Carré",
  "dboard_combo":"-Duo",

  "dboard_bolus_calculator":"Calculateur de bolus (volume/nombre par jour)",
  "dboard_food_bolus":"-Calculateur Bolus alimentaire",
  "dboard_corr_bolus":"-Calculateur Bolus de Correction",
  "dboard_override_add":"- Ignorer (+)",
  "dboard_override_sub":"- Ignorer (-)",

  "dboard_report":"Tableau de bord Rapport",

  "daily":"Résumé quotidien",
  "date":"Date",
  "print":"Imprimer",
  "carbs":"Glucides",
  "exercise":"Exercise",
  "heavy":"Exercice lourd",
  "Medium":"Exercice moyen",
  "Light":"Exercice léger",
  "dailyReport":"Rapport récapitulatif quotidien",
  "devices":"Dispositifs",
  "tran":"Transmetteur ",
  "pumpBase":"Base de Pump ",
  "HbA1c":"HbA1c",
  "statics":"Statistiques",
  "glucose":"Glucose",
  "item":"élément",
  "BG1":"glucose sanguin",
  "SG1":"capteur de glucose",
  "avgSD":"moyenne déviation standard",
  "avgSD1":"Moyenne±SD",
  "min":"Min",
  "max":"Max",
  "ofRead":"nombre de lectures",
  "ofHypo":"nombre d'épisodes d'hypoglycémie/durée(min)",
  "ofAlert":"Nombre d'alertes",
  "insulin":"Insulin",
  "insulin2":"Insuline",
  "totalDose":"Dose quotidienne totale",
  "foodBolus":"Bolus alimentaire",
  "Food+coor":"Food+corr",
  "calibBolus":"Bolus de correction",
  "durationStop":"Durée de la suspension(min)",
  "ofPumpAlert":"Nombre d'alarmes de pompe",
  "ofMeal":"# de repas",
  "totalExerTime":"Temps d'exercice total",
  "exerNum":"# d'exercices",
  "avgInten":"Intensité moyenne",
  "target1":"Cible",
  "high1":"Haute",
  "low1":"Bas",
  "BG Reading":"BG Reading",

  "dayByday":"Jour après jour",
  "dayBydayRe":"Rapport d'aperçu au jour le jour",
  "period":"Période",

  "sensorOverlay":"Superposition de capteur",
  "set":"Réglages",
  "setPeriod":"regler periode",
  "Weekdays":"Jours de la semaine",
  "Weekends":"Weekends",
  "Mon":"Lun",
  "Tue":"Mar",
  "Wed":"Mer",
  "Thur":"Jeu",
  "Thu":"Jeu",
  "Fri":"Ven",
  "Sat":"Sam",
  "Sun":"Dim",
  "Average":"Moyen",
  "sensorOlRe":"Rapport de superposition de capteurs",
  "Avg":"Moyen",
  "±SD":"±SD",
  "ofhypo":"nombre d'épisodes d'hypoglycémie",
  "Everyday":"tous les jours",

  "TrendAna":"Analyse de tendance",
  "TrendRe":"Rapport d'analyse des tendances",
  "sensorGlu":"Glucose du capteur ",
  "ofBGtest":"nombre de tests de glycémie",
  "Basics":"Base",
  "static":"Statistiques",
  "Med":"Moyen",
  "med":"median",
  "Q1":"Q1",
  "Q3":"Q3",
  "Q11":"Q1",
  "Q31":"Q3",
  "IQR":"gamme interquartile",
  "SD":"SD",
  "CV":"Coefficient de variation",
  "SE1":"Erreur standard de la moyenne",
  "distri":"Distribution",
  "stab":"La stabilité",
  "#high":"nombre de lectures de glucose élevées",
  "#low":"nombre de lectures de glucose faibles",
  "aucBelow":"Surface sous la courbe en dessous de la limite basse",
  "aucAbove":"Surface sous la courbe au-dessus de la limite haute",
  "bgRead":"lectures de glucose sanguin",
  "total":"Totale",
  "ofBolus":"Nombre de bolus",
  "avgBolus":"Bolus moyen",
  "Dura1":"Durée (min)",
  "Avg/Total":"Moy / Total",
  "high":"Haute",
  "low":"Bas",
  "#hypo":"nombre d'épisodes d'hypoglycémie",
  "ofExer":"# d'exercices",

  "logbook":"Registre",
  "dailyTotal":"Total quotidien",
  "High Glucose":"Glucose élevée",
  "Low Glucose":"Glucose bas",
  "No Active Patch":"Pas de réservoir actif",
  "Missed Meal":"Repas manqué",
  "Multiple BG Readings":"Lectures multiples de glycémie",
  "Stop Patch":"Arrêter le réservoir ",
  "Others":"Autres",
  "Other Events":"Autres événements",
  "logRe":"Rapport de journal de bord",

  "DeviceSetting":"Examen des réglages de dispositif",
  "Insulin Pump":"Pompe à insuline",
  "MaxBasalRate":"Taux basal maximum",
  "BasalPatterns":"Modèle basal",
  "Selected Basal Pattern":"sellectionner modèle basal",
  "Maximum Bolus":"Bolus maximum",
  "Combo/Extended Bolus":"bolus combo/extendu",
  "BG Reminder":"Rappelde glucose sanguin",
  "Bolus Increment":"Incrément de bolus",
  "Bolus Calculator":"Calculatrice de bolus",
  "Active Insulin Time":"Temps d'insuline active",
  "IC Ratios":"Rapports insuline-glucides ",
  "Insulin Sensitivity":"Sensibilité à l'insuline",
  "BG Target":"Cible de glycémie",
  "Bolus Reminder":"Rappel de Bolus",
  "CGM":"MCG",
  "CGM System":"Système CGM",
  "Glucose Unit":"Unité de glucose",
  "Glucose Limits":"Limites de glucose",
  "Predicitive Alerts":"Alertes prédictives",
  "Rate Alerts":"taux de Alertes ",
  "type":"Type",
  "time":"L'heure",
  "data":"Data",
  "Rate":"Rate",
  "Calibration Reminder":"Rappel de calibrage",
  "Calibration Repeat":"Répétition de calibrage",
  "Snooze":"Répetition",
  "Audio Options":"Options audio",
  "Confidence Reminder":"Rappel de confiance",
  "Backlight":"Rétro-éclairage",
  "Sec":"secondes",
  "Alarm Clock":"Réveil",
  "Patch Expiration":"Expiration du réservoir",
  "Sensor Expiration":"Expiration du capteur",
  "Hourly Max":"Max horaire",
  "Daily Max":"Max quotidien",
  "Low Reservoir":"Réservoir bas",
  "Low Suspend":"suspension bas",
  "Predictive Low Suspend":"suspension bas projeté",
  "Rise":"Augmenter",
  "Fall":"Chute",
  "Auto Off":"Arrêt automatique",
  "Standard":"Standard",
  "Exercise":"Exercise",
  "Holiday":"Vacances",
  "ProgramA":"Modèle A",
  "ProgramB":"Modèle B",
  "--":"--",
  "Insulin":"Insulin",

  "SUSA":"Auto Off",
  "SUSHM":"Dépasse la livraison maximale de 1 heure",
  "SUSDM":"Dépasse Max TDD",
  "SUSLSG":"Faible suspension",
  "SUSPLSG":"Prédictive faible suspension",
  "Pump Restarted":"Pompe redémarrée",
  "Meter BG Now":"entrer une valeur de glycémie mètre maintenant",
  "Sensor Exp in 2 Hours":"Sensor Exp en 2 heures",
  "Sensor Exp in 6 Hours":"Sensor Exp en 6 heures",
  "Sensor Exp in 30 Min":"Capteur Exp dans 30 Min",
  "Sensor Calibration Error":"Erreur d'étalonnage du capteur",
  "Sensor Error":"Pas de lectures",

  "Device Settings Report":"Rapport des réglages de l'appareil",
  "24h Total":"Total de 24h",
  "Device Settings at":"dispositif réglé à",
  "Start":"Démarrer",
  "Combo/Ext Bolus":"Bolus Duo/Carré",
  "Time Format":"Format de l'heure",
  "Device Options（CGM System)":"Options de dispositf (système CGM)",
  "Device Options（Insulin Pump)":"Options de dispositf (Pompe à insuline)",
  "Dispay Settings (Screen)":"réglages d'affichage (écran)",
  "Dispay Settings (Backlight)":"réglages d'affichage (Rétro-éclairage)",
  "Graph Range":"Plage de graphes",
  "Range":"Plage",
  "Repeat":"Répéter",
  "Glucose Alerts":"Alertes au glucose",
  "Alert Silence":"Silence d'alerte",

  "Create":"Créer",
  "Event Filter":"Filtre d'événement",
  "HbA1c1":"HbA1c",
  "Urine Ketone":"Cétone d'urine",
  "Injection":"Injection",
  "Other":"Autre",
  "Event Type":"Type d'événement",
  "Details":"Détails",
  "Notes":"Remarques",
  "Source":"La source",
  "edit":"Modifier",
  "Action":"Action",
  "EventReport":"Rapport de synthèse de l'événement",
  "By Date":"Par date",
  "By Category":"Par catégorie",
  "Event Summary":"Résumé des événements",
  "No data":"Pas de données",
  "No1":"Pas de",
  "data1":"données",
  "#":"#",
  "BG Summary":"Résumé de glucose sanguin",
  "Carbs Summary":"Résumé des glucides",
  "Injection Summary":"Résumé de l'injection",
  "Exercise Summary":"Résumé de l'exercice",
  "Input Notes":"Saisir un commentaire",

  "Profile":"Profil",
  "Complications":"Complications",
  "Concomitant diseases":"Maladies concomitantes",
  "Suggestion":"Suggestion",
  "Coronary heart disease":"Maladie coronarienne",
  "High blood lipids":"Lipides sanguins élevés",
  "High blood pressure":"Hypertension",
  "Kidney disease":"Maladie rénale",
  "Neuropathy":"Neuropathie",
  "Obesity":"Obésité",
  "Peripheral arterial disease":"Maladie artérielle périphérique",
  "Retinopathy":"Rétinopathie",
  "Smoking addiction":"Dépendance au tabac",
  "Enter date":"Entrez la date",
  "Enter suggestion":"Entrez une suggestion",
  "Enter Notes":"Ajouter une note",
  "Select":"Sélectionner",
  "Prescription":"Prescription",
  "Medicine":"Médicament",
  "Dose":"Dose",
  "Enter medicine":"Entrez la médecine",
  "Enter dose":"Entrer la dose",
  "Enterdis":"Entrez la maladies concomitantes",
  "Add note":"Ajouter une note",
  "Add Content":"La longueur maximale est de 1000 caractères.",
  "Other suggestions":"Autres suggestions",
  "OK":"OK",
  "HCP":"HCP",
  "Content":"Contenu",
  "Records Report":"Rapport sur les documents",

  "Quick Print":"Impression rapide",
  "Quick Print Settings":"Réglages d'impression rapide",
  "Select duration":"Sélectionnez la durée",
  "One Week":"Une semaine",
  "One Month":"Un mois",
  "One Quarter":"Un quart",
  "End date":"Date de fin",
  "Yesterday":"Hier",
  "Last Sunday":"Dimanche dernier",
  "Last Saturday":"Samedi dernier",
  "Last Day of Last Month":"Last Day of Last Month",
  "Last Day of Last Quarter":"Last Day of Last Quarter",
  "Customized":"Personnaliser",
  "Week Filter":"Filtre de la semaine",
  "Select reports to print":"Sélectionnez les rapports à imprimer",
  "Daily Summary":"Résumé quotidien",
  "Day By Day Overview":"Jour après jour",
  "Sensor Overlay":"Superposition de capteur",
  "Trend Analysis":"Analyse de tendance",
  "Logbook":"Registre",
  "Device Settings Review":"Examen des réglages du dispositif",
  "createReport":"Créer un Rapport",

  "Segment Analysis":"Analyse des segments",
  "Sensor Glucose Profile":"Profile du capteur de glucose",
  "# of Boluses":"Nombre de bolus",
  "Bolus Insulin":"Bolus insuline",
  "Basal Pattern":"Modèle basal",
  "Segment Analysis Report":"Rapport d'analyse sectorielle",
  "Avg Glucose":"Glucose moyen",
  "Below":"En dessous",
  "In Target Range":"Dans la cible",
  "Coefficient of variation":"Coefficient de variation",
  "% Time CGM Active":"% temps MCG active",
  "est_a1c_t1":"Estimated A1C:",
  "est_a1c_t2":"calculated from SG values",
  "est_a1c_t3":"Note : hbA1C estimée ne remplace pas un dosage au laboratoire.",

  "acceptTip":" vous a permis de visualiser à distance ses informations de santé.",
  "cancelTip":" a cessé de vous permettre de visualiser à distance ses informations de santé. Vous pouvez postuler à nouveau si nécessaire.",
  "rejectTip":" a rejeté votre application de visualisation à distance.",
  "Read":"lire",

  "Connection":"Connexion",
  "connections1":"Connexion",
  "Add Connection":"Ajouter une connexion",
  "SG":"Valeur de glucose",
  "Active Insulin":"Insuline active",
  "Stop following":"Arrête de suivre",
  "Enter username (email)":"Entrez le nom d'utilisateur (email)",
  "Search results":"Résultats de la recherche",
  "Send request":"Envoyer une demande",
  "View graphs":"Voir les graphiques",
  "Agree":"Se mettre d'accord",
  "Deny":"Refuse",
  "Remove":"Enlever",
  "Cancel Requset":"Annuler la demande",
  "Remark":"Remarque",

  "Warm up":"Réchauffer",
  "Monitoring":"suivi",
  "Transmitter Error":"Erreur de transmetteur",
  "Sensor Failure":"Défaillance du capteur",
  "Sensor Expired":"Capteur expiré",
  "Lost Sensor":"Capteur perdu",
  "Not Calibrated":"Non calibré",
  "Calibrating":"Calibration",
  "Calibration Needed":"Calibration nécessaire",
  "Calibration Error":"Erreur de calibrage",
  "Charging Battery":"Charge de la batterie",
  "Battery Charged":"Batterie chargée",

  "To be filled":"Être rempli",
  "Filled with insulin":"Rempli d'insuline",
  "Priming":"Amorçage",
  "Priming completed":"Apprêt terminé",
  "Inserting needle":"Insérer une aiguille",
  "Patch activated":"réservoir activé",
  "Delivering Basal":"administrer Basal",
  "Exceeds Max 1 Hour Delivery":"Dépasse la livraison maximale de 1 heure",
  "Exceeds Max TDD":"Dépasse Max TDD",
  "Suspend":"Suspendre",
  "Occlusion Detected":"Occlusion détectée",
  "Patch Expired":"Réservoir expiré",
  "Empty Reservoir":"Réservoir vide",
  "Patch Error":"Erreur de pompe",
  "Pump Base Error":"Erreur de base de pompe",
  "Patch Battery Depleted":"Patch batterie appauvri",
  "Magnetic sensor not calibrated":"Capteur magnétique non calibré",

  "Patient Profile":"Profil du patient",

  "On":"démarer",
  "on":"démarer",
  "Off":"éteindre",
  "off":"éteindre",

  "CORONARY_HEART_DISEASE":"Maladie coronarienne",
  "HIGH_BLOOD_LIPIDS":"Lipides sanguins élevés",
  "HIGH_BLOOD_PRESSURE":"Hypertension",
  "KIDNEY_DISEASE":"Maladie rénale",
  "NEUROPATHY":"Neuropathie",
  "OBESITY":"Obésité",
  "PERIPHERAL_ARTERIAL_DISEASE":"Maladie artérielle périphérique",
  "RETINOPATHY":"Rétinopathie",
  "SMOKING_ADDICTION":"Dépendance au tabac",

  "saveTip":"Enregistré avec succès.",
  "changePaTip":"Votre mot de passe a été changé.",
  "enterEmTip":"Entrez votre adresse email.",
  "verErrTip":"Code de vérification incorrect.",
  "chooseEventTip":"Choisissez les événements à imprimer",
  "chooseDataTip":"Sélectionnez les données à imprimer",
  "dateWrongTip":"La date de fin ne peut pas être antérieure à la date de début",
  "infoWrongTip":"Veuillez remplir tous les champs requis.",
  "createdSuccssTip":"Créé avec succès",
  "selectData":"Sélectionnez les données à sauvegarder",

  "acceSu":"Demande de connexion acceptée",
  "acceEr":"mpossible d'ajouter une nouvelle connexion",
  "rejeSu":"Demande de connexion rejetée",
  "rejeEr":"Échec de la demande de rejet",

  "userNotExist":"Le nom d'utilisateur n'existe pas.",
  "Password incorrect":"Mot de passe incorrect.",
  "UserType incorrect":"Type d'utilisateur incorrect",

  "registSuccess":"Votre compte à été créé avec succès.",
  "registFailed":"Impossible d'enregistrer un nouveau compte",
  "sentSuccess":"message envoyé avec succès",
  "sentFailed":"Échec de l'envoi du message",
  "Input error":"Erreur de saisie",

  "deletePtip":"Êtes-vous sûr de vouloir supprimer ces patients?",
  "deleteEvents":"Etes-vous sur de vouloir supprimer ces évènements?",
  "deleteData":"Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis":"Etes-vous sur de vouloir supprimer?",
  "confirm":"Confirmer",
  "deleteSuccess":"Supprimé avec succès",
  "deleteFailed":"Échec de changement",
  "modifySuccess":"Changé avec succès",
  "modifyFailed":"Échec de changement",
  "createSuccess":"Créé avec succès",
  "createFailed":"La création a échoué",
  "editSuccess":"Modifié avec succès",
  "editFailed":"Echec de modification",
  "Time overlapped":"Les sessions que vous avez sélectionnées se chevauchaient.",

  "stopFollow":"Souhaitez-vous arrêter le suivi de ce patient?",
  "CancelTip1":"Êtes-vous sûr de vouloir supprimer cette connexion?",

  "Warning":"Attention",
  "agreeConnect":"Si vous cliquez sur 'Accepter' pour accepter la demande de connexion, vos données de santé deviendront disponibles pour la nouvelle connexion.",
  "denyConnect":"Êtes-vous sûr de vouloir rejeter la demande de connexion?",
  "deleteConnect":"Êtes-vous sûr de vouloir supprimer cette connexion? Si vous le supprimez, la connexion ne pourra plus afficher vos données de santé.",

  "Choose the events to print":"Choisissez les événements à imprimer",
  "tryAgain":"Réessayer",
  "username and password is required":"username and password is required",
  "A name is required":"Un nom est requis",
  "username is required":"Nom d'utilisateur est nécessaire.",
  "The date choose wrong":"Date incorrecte",
  "Date no more than 14 days":"Vous ne pouvez pas sélectionner plus de 14 jours.",

  "CancelTip":"Êtes-vous sûr de vouloir supprimer la connexion?",
  "removeConnect":"Supprimé avec succès",

  "dateErr1":"Vous ne pouvez pas sélectionner plus de 90 jours.",
  "dateErr2":"La date de fin ne peut pas être antérieure à la date de début.",

  "Not Filled":"Non spécifié",
  "Today":"Aujourd'hui",
  "duration":"Durée",
  "interval":"Interval",
  "7 days":"7 jours",
  "14 days":"14 jours",
  "30 days":"30 jours",
  "90 days":"90 jours",
  "g":"g",

  "Sound+Vibrate":"Audio+Vibration",
  "Sound":"Audio",
  "Vibrate":"Vibration",
  "Silent":"Ne pas déranger",
  "1":"Une fois ",
  "2":"Quotidien",
  "noMes":"Il n'y a pas de messages.",
  "noConnect":"Il n'y a pas de connexions..",
  "Customize":"Personnaliser",
  "GB":"United Kingdom",
  "CN":"China",
  "FR":"France",
  "DD":"Germany",
  "DE":"Germany",
  "SE":"Sweden",
  "AU":"Australia",
  "HKF":"Hongkong",
  "HU":"Hungary",
  "IT":"Italy",
  "NL":"Netherlands",
  "Nor":"Norway",
  "PT":"Portugal",
  "ES":"Spain",
  "TR":"Turkey",

  "Jan":"Jan",
  "Feb":"Fév",
  "Mar":"Mar",
  "Apr":"Avr",
  "May":"Mai",
  "Jun":"Jun",
  "Jul":"Jul",
  "Aug":"Aoû",
  "Sep":"Sep",
  "Oct":"Oct",
  "Nov":"Nov",
  "Dec":"Déc",
  "ApplyTip":"  demande d'afficher vos données.",
  "noReadings":"Pas de lectures",

  "daop_A6_system":"A6 Touchcare System",
  "daop_easytouch_easyview":"EasyTouch / EasyView iPad",
  "daop_TY012_TY015":"TY012/TY015",
  "daop_easysense":"EasySense",
  "daop_delete_data":"Delete Data",
  "daop_uploaded_data":"Données transmises",
  "daop_uploaded_data_text":"Donnée de l'app EasyTouch ou EasyView (pour IPAD)",
  "daop_realtime_data":"Donnée en Temps Réel",
  "daop_realtime_data_text":"The data is from EasySense App or EasyPatch App.",

  "ins_unit":"(U)",
  "ins_unit2":"U",
  "basal_unit":"Unités / heure",
  "basal_unit2":"U/H",

  // 告警
  "Alerts_Patch_Battery_Low":"batterie de reservoir faible",
  "Alerts_Patch_Battery_Depleted":"batterie de reservoir appauvri", // update
  "Alerts_Lost_Pump":"Lost Pump",
  "Alerts_Low_Reservoir":"Réservoir bas", // update
  "Alerts_Empty_Reservoir":"Réservoir vide",
  "Alerts_Patch_Expiration_Advisory":"Avis d'expiration de  reservoir",
  "Alerts_Patch_Exp_In_1_Hour":"Patch Exp In 1 Hour",
  "Alerts_Patch_Expired":"reservoir expiré", // update
  "Alerts_Patch_Error":"Erreur de pompe",
  "Alerts_Pump_Base_Error":"Erreur de base de pompe",
  "Alerts_Basal_Rate_Key_Error":"Basal Rate Key Error",
  "Alerts_Occlusion_Detected":"Occlusion détectée", // update
  "Alerts_End_Of_Suspend":"End Of Suspend",
  "Alerts_Exceeds_Max_TDD":"Dépasse Max TDD", // update
  //"Alerts_Exceeds_Max_TDD":"Exceeds Max TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery":"Dépasse la livraison maximale de 1 heure",
  //"Alerts_Exceeds_Max_1Hr_Delivery":"Exceeds Max 1Hr Delivery",
  "Alerts_Predictive_Low_Suspend":"Prédictive faible suspension", // update
  "Alerts_Low_Suspend":"suspension bas",
  "Alerts_Auto_Off":"Arrêt automatique", // update

  "Alerts_Pump_Restart":"Pump Restart",  // 22
  "Alerts_Auto_Off_Warning":"Auto Off Warning",  // 23
  "Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //24
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  // 25
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //33

  "Alerts_Lost_Sensor":"Capteur perdu", // update
  "Alerts_Transmitter_Battery_Low":"Batterie de l'émetteur faible",
  "Alerts_Charge_Transmitter":"Transmetteur de charge",
  "Alerts_Sensor_Error":"Pas de lectures",
  "Alerts_Transmitter_Error":"Erreur de transmetteur",
  "Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  //"Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  "Alerts_Sensor_Failure":"Défaillance du capteur",
  "Alerts_Sensor_Calibration_Reminder":"Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now":"entrer une valeur de glycémie mètre maintenant",
  "Alerts_Sensor_Exp_in_6_Hours":"Sensor Exp en 6 heures",
  "Alerts_Sensor_Exp_in_2_Hours":"Sensor Exp en 2 heures", // update
  "Alerts_Sensor_Exp_in_30_Min":"Capteur Exp dans 30 Min",
  "Alerts_Sensor_Expired":"Capteur expiré", // update
  "Alerts_Rapid_Rise":"Hausse rapide",
  "Alerts_Rapid_Fall":"Chute rapide",
  "Alerts_High_Predicted":"Haute prédite",
  "Alerts_Low_Predicted":"Faible",
  "Alerts_High_Glucose":"Glucose élevée", // update
  "Alerts_Low_Glucose":"Glucose faible", // update
  "Alerts_Below_3.1_mmol/L":"En dessous de 3.1 mmol/L",
  "Alerts_Transmitter_Battery_Low_2":"Batterie de l'émetteur faible",

  "Alerts_PDM_Battery_Low":"Batterie PDM faible",
  "Alerts_Replace_Battery":"Charger PDM ",

  // Alert页面
  "Alert":"Alert",
  "Alerts":"Alertes",
  "Alert Filter":"Alert Filter",
  "PDM":"PDM",
  "Pump":"Pompe",
  //"CGM":"CGM",

  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode":"Temps en Mode Auto",
  "t1221_Average_SG_SD":"Moyenne GC ± DS",
  "t1221_Time_in_Target_Range":"Temps dans la cible",
  "t1221_Time_above_Range":"Temps au-dessus de la cible",
  "t1221_Time_below_Range":"Temps en dessous de la cible",
  "t1221_Auto_Basal_per_day":"Basal Auto (par jour)",
  "t1221_Auto_Bolus_per_day":"Bolus Auto (par jour)",
  "t1221_Auto_Mode_Exits":"Sorties du Mode Auto",
  "t1221_No_Sensor_readings":"Pas le lecture du capteur",
  "t1221_Max_Delivery":"Administration max",
  "t1221_Min_Delivery":"Administration min",
  "t1222_autoModeBasal":"Mode Auto - Basal",
  "t1222_autoModeCorrBolus":"Mode Auto - Bolus de correction",
  "t1222_autoSnack":"Auto Collation",
  "t1222_autoBreakfast":"Auto Petit-Déjeuner",
  "t1222_autoLunch":"Auto Déjeuner",
  "t1222_autoDinner":"Auto Diner ",
  "t1222_autoExercise":"Auto Exercice",
  "t1222_Snack":"Collation",
  "t1222_Auto_Mode":"Mode Auto ",
  "t1222_Time_in_Auto_Mode":"Temps en Mode Auto(%)",
  "t1222_Avg_SD":"Moy.(mg/dl)±GC",
  "t1222_Target_Range":"Dans la cible (%)",
  "t1222_Above_Range":"Au-dessus de la cible(%)",
  "t1222_Below_Range":"En dessous de la cible(%)",
  "t1222_Auto_Mode_Exits":"# de sorties du Mode Auto",
  "t1221_Auto_Mode":"Mode Auto",
  "t1222_auto_basal":"Basal Auto",
  "t1222_auto_bolus":"Bolus Auto",
  "t0805_User_Management":"Gestion des utilisateurs",
  "t0805_Patient_Management":"Gestion des patients",
  "t0805_Operation_History":"Historique des opérations",
  "t0805_User_List":"liste d'utilisateur",
  "t0805_User":"Utilisateur",
  "t0805_Time":"Temps",
  "t0805_Operation_Type":"Type d'opération",
  "t0805_Back":"Retour",
  "t0805_Add":"Ajouter",
  "t0805_Delete":"Supprimer",
  "t0809_Add_User":"Ajouter un utilisateur",
  "t1028_Pattern_C":"Modèle C",
  "t1028_Pattern_D":"Modèle D",
  "t1029_Auto_meal_bolus":"Auto meal bolus",
  "t1029_Auto_mode_correction_bolus":"Auto mode correction bolus",
  "t1029_Sick":"Malade",
  "t1029_Auto_Mode_Feature":"Fonction Mode Auto",
  "t1029_Target_SG":"Glucose cible",
  "t1029_Auto_Meal_Handling":"Gestion auto repas",
  "t1029_Total_Daily_Dose":"Total quotidien",
  "t1029_Pump_Light":"Témoin lumineux",
  "t1029_Alerts_for_Hypo":"Alertes Hypo",
  "t1102_Out_of_Range":"Hors de portée",
  "t1102_Command_Reminder":"Rappel commande",
  "t1102_Alarms_Alerts_on_APP":"Alarmes & Alertes sur System",
  "t1102_Alarms_on_App":"Alarmes sur l'APP",
  "t1102_Alerts_on_App":"Alertes sur l'APP",
  "t1102_Factory_Calibration":"Calibration usine",
  "t1102_Alerts_for_Low":"Alertes pour basse ",
  "t1102_Alerts_for_High":"Alertes pour Haute ",
  "t1102_Alerts_for_Others":"Alertes pour les autres ",
  "t1102_Adjustment":"Ajustement",
  "t1102_Suggested":"Suggéré",
  "t1103_Glucose":"Glucose",
  "t1103_CGM":"CGM",
  "t1103_Insulin":"Insuline",
  "t1103_Carbs":"Glucides",
  "t1103_Exercise":"Exercice",
  "t1103_Min_Max":"Min/Max",
  "t1103_Target_Range":"Intervalle cible",
  "t1103_Overall_Tine_In_Range":"Général : Temps dans la cible",
  "t1103_Basal":"Basal",
  "t1103_Bolus":"Bolus",
  "t1103_Basal_Bolus":"Basal et Bolus",
  "t1103_Auto_Mode_Time_In_Range":"Mode Auto : Temps dans la cible",
  "t1103_Time_below_range":"Temps en dessous de la cible",
  "t1103_Time_above_range":"Temps au-dessus de la cible",
  "t1103_Time_in_target_range":"Temps dans la cible",
  "t1103_Incorrect_Password":"Mot de passe incorrect, $1 Tentative laissée, veuillez saisir le mot de passe correct.",
  "t1103_Incorrect_locked":"Les tentatives infructueuses dépassent la limite, le compte a été verrouillé. Veuillez réessayer dans $1 minutes.",
  "t1104_The_data_is_from":"Donnée de l'app EasySense ou EasyPatch.",
  "t1104_Privacy_Policy":"Politique de confidentialité et conditions d'utilisation",
  "t1104_updated_privacy_policy":"Nous avons mis à jour notre politique de confidentialité et conditions d'utilisation.Veuillez lire attentivement et accepter les modifications avant de utiliser EasyPatch",
  "t1104_Disagree":"Non",
  "t1104_Agree":"Se mettre d'accord",
  "t1105_Upload_History":"Télécharger l'historique",
  "t1105_Delete_Data":"Suprimmer les données",
  "t1105_Target_Range":"Intervalle cible",
  "t1105_request_to_view_your_data":"$1 de demande pour afficher vos données.",
  "t1105_Recent_Updates":"Mises à jour récentes",
  "t1108_No_data":"Pas de données",
  "t1108_Pump_Bash_SN":"NS Base de Pump ",
  "t1108_Transmitter_SN":"Transmetteur NS",
  "t1112_Normal_Glucose":"Glycémie Normale",
  "t1112_Manual_Bolus_or_Modified_Bolus":"Bolus manuel ou bolus modifié",
  "t1112_Auto_Mode_Started":"Début du Mode Auto",
  "t1112_Auto_Mode_Exit":"Fin du Mode Auto",
  "t1112_Normal_Bolus":"Bolus Normal",
  "t1112_Extended_Bolus":"Bolus Carré ",
  "t1112_Combo_Bolus":"Bolus Combo",
  "t1112_Carbs":"Glucides",
  "t1112_Glucose":"Glucose",
  "t1112_BG":"Glycémie",
  "t1112_Audio":"Son ",
  "t1112_Tone":"Tonalité",
  "t1112_Audio_Options":"Options audio",
  "t1112_Weight_Unit":"Unité De Poids",
  "t1112_Height_Unit":"Unité De Hauteur",
  "t1112_Not_available":"Pas Disponible",
  "t1112_Number":"Numéro",
  "t1112_days":"# jours",
  "t1112_min":"Min",
  "t1113_days":"jours",
  "t1215_Security":"Sécurité",
  "t1215_MFA":"Authentification multifacteur (MFA)",
  "t1215_Enter_verification_code":"Entrez le code de vérification",
  "t1215_Multi_factor_ON":"L'authentification multifacteur est activée. Le code de vérification a été envoyé à $1 Veuillez soumettre le code de vérification.",
  "t1215_Verification_code_incorrect":"Code de vérification incorrect",
  "t1215_Show_Glucose_Value":"Afficher la valeur de glucose",
  "t1221_enter_verification_code":"Veuillez saisir le code de vérification à 6 chiffres envoyé à $1.",
  "t1221_Verification_Success":"Vérifié avec succès",
  "t1222_We_will_only_process":"Vos données de santé seront traitées à partir de l'app/du Portail Medtrum uniquement avec votre consentement.  ",
  "t1222_If_you_are_under_years":"L'ouverture d'un compte pour un mineur de moins de 16 ans requiert l'autorisation de vos parents ou tuteur légal.",
  "t1221_register_cn":"Vous disposez du droit de ne pas télécharger les données de vos dispositif sur l'App. Dans ce cas, vos données ne pourront pas être consultées par un tiers. Si vous n'ouvrez pas de compte Medtrum sur le portail web ou notre App., vos données seront uniquement enregistrées sur le dispositif que vous utilisez. ",
  "t1221_register_eu":"Si vous créez un compte Medtrum pour accéder à notre application, vos donnés de santé enregistrées sur l'App. seront téléchargées sur notre serveur européen et conservées pendant 2 ans. Vous êtes libre de ne pas téléchargées vos données sur l'App. Dans ce cas, vos données ne pourront être consultées par aucun tiers à distance. Si vous n'ouvrez pas de compte Medtrum sur le portail web ou notre App., vos données seront uniquement enregistrées sur le dispositif que vous utilisez.",
  "t1221_register_follow":"Le traitement de vos données de santé sera effectué à partir de l'app/du Portail Medtrum, uniquement avec votre consentement",
  "t1222_Terms_of_Use":"les conditions d'utilisation de Medtrum",
  "t1222_Privacy_Policy":"la politique de confidentialité de Medtrum",
  "t1222_Create_Account":"Créer un compte",
  "t1222_Back":"retour",
  "t1222_Verify_your_account":"Vérifiez votre compte",
  "t1222_please_check_your_account":"Nous enverrons un code de vérification à $1, veuillez vérifier votre compte.",
  "t1222_I_Agree_to":"J'accepte $1",
  "t1223_Invalid_Verification_Code":"Code de vérification invalide. Veuillez réessayer.",
}

//export default {frMessages}



// WEBPACK FOOTER //
// ./src/lang/fr.js